import { Component, HostListener, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'atr-site-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <header class="site-header" [class.is-scrolled]="isScrolled()">
      <a class="brand" routerLink="/" aria-label="ATR Automotive Detailing home">
        <img src="assets/atr-logo.png" alt="ATR Automotive Detailing" />
      </a>
      <nav class="nav" aria-label="Primary navigation">
        <a routerLink="/services" routerLinkActive="active">Services</a>
        <a routerLink="/results" routerLinkActive="active">Results</a>
        <a routerLink="/book" routerLinkActive="active">Contact</a>
      </nav>
      <a class="header-call" href="tel:+13093355423">309-335-5423</a>
    </header>
  `,
})
export class SiteHeaderComponent {
  protected readonly isScrolled = signal(false);

  @HostListener('window:scroll')
  protected onWindowScroll(): void {
    this.isScrolled.set(window.scrollY > 28);
  }
}
